import *as React from 'react';
import ContentLoader from "react-content-loader";

export const WorkkardDetailPopupLoader = props =>{
    return(
        <>
            {props.count && props.count > 0 && (
                Array.from({ length: props.count }, (_, i) => (
                <div className="mb">
                    <ContentLoader 
                    speed={2}
                    width={558}
                    height={41}
                    viewBox="0 0 558 41"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                    >
                    <rect x="270" y="6" rx="3" ry="3" width="94" height="12" /> 
                    <rect x="270" y="25" rx="3" ry="3" width="175" height="12" /> 
                    <rect x="12" y="6" rx="3" ry="3" width="94" height="12" /> 
                    <rect x="12" y="25" rx="3" ry="3" width="175" height="12" />
                    </ContentLoader>
                </div>
                ))
            )}
        </>
    );
}